import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { DEFAULT_CURRENCY } from 'partner360/features/QBR/configs'

import { OVERALL_CATEGORY } from '../../lib'
import { isPeriodOpen as getIsPeriodOpen } from '../../lib/isPeriodOpen'
import {
  selectCockpitCategory,
  selectCockpitCurrency,
  selectCockpitMetric,
  selectCockpitOffering,
  selectCockpitShowQuota,
  selectIsCockpitPrevFYearClosing,
} from '../selectors'
import { selectCockpitPeriods } from '../selectors/selectCockpitPeriods'

import { useEffectiveActualsSync } from './useEffectiveActualsSync'

export const useCockpitSettings = () => {
  const actualsType = useSelector(selectCockpitMetric)
  const currency = useSelector(selectCockpitCurrency)
  const periods = useSelector(selectCockpitPeriods)
  const showQuota = useSelector(selectCockpitShowQuota)
  const selectedCategory = useSelector(selectCockpitCategory)
  const selectedOffering = useSelector(selectCockpitOffering)
  const isPrevFYearClosing = useSelector(selectIsCockpitPrevFYearClosing)

  const {
    fYear: selectedFYear,
    currentFQuarter,
    fQuarterActualsPercentage,
  } = useEffectiveActualsSync()

  const isYtd = useMemo(() => periods.includes('ytd'), [periods])
  const isLocalCurrency = useMemo(() => currency !== DEFAULT_CURRENCY, [currency])
  const isPeriodOpen = useMemo(
    () => getIsPeriodOpen(periods, currentFQuarter),
    [periods, currentFQuarter]
  )

  return {
    isYtd,
    isLocalCurrency,
    actualsType,
    currency,
    selectedCategory: selectedCategory ?? OVERALL_CATEGORY,
    selectedOffering,
    showQuota,
    periods,
    isPeriodOpen,
    isPrevFYearClosing,
    selectedFYear,
    currentFQuarter,
    fQuarterActualsPercentage,
  }
}
